/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss'

import React, { useRef, useEffect } from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

import Label from '../Label'
import Button from '../Button'

const bem = new BEMHelper('input')

const autoExpand = ({ target }) => {
  target.style.height = 'inherit'
  target.style.height = `${target.scrollHeight + 6}px`
}

export default function Input({
  label,
  mask,
  textarea,
  className,
  error,
  small,
  reference,
  required,
  disabled,
  tooltip,
  readOnly,
  short,
  button,
  spacing,
  ...props
}) {
  const wrapperRef = useRef()
  const Node = textarea ? 'textarea' : 'input'
  const extraProps = textarea ? { onInput: autoExpand } : null
  const hidden = props.type === 'hidden'

  useEffect(() => {
    if (wrapperRef.current && textarea) {
      autoExpand({
        target: wrapperRef.current.querySelector(`.${bem('input').className}`),
      })
    }
  })

  return (
    <Label
      label={label}
      tooltip={tooltip}
      error={error}
      small={small}
      required={required}
      spacing={spacing}
      className={className}
      readOnly={readOnly}
      {...bem('', {
        hidden,
        error,
        disabled,
        small,
        'no-label': !label,
        'read-only': readOnly,
        short,
      })}
    >
      <div {...bem('wrapper')} ref={wrapperRef}>
        <Node
          {...props}
          {...bem('input', { textarea })}
          disabled={disabled}
          readOnly={readOnly}
          ref={reference}
          {...extraProps}
        />
        {button && (
          <Button small {...bem('button')} {...button}>
            {button.label}
          </Button>
        )}
      </div>
    </Label>
  )
}

Input.propTypes = {
  id: T.string,
  label: T.string,
  className: T.string,
  value: T.string,
  mask: T.string,
  textarea: T.bool,
  placeholder: T.string,
  error: T.string,
  tooltip: T.string,
  small: T.bool,
  type: T.string,
  reference: T.oneOfType([T.func, T.object]),
  required: T.bool,
  disabled: T.bool,
  spacing: T.bool,
  readOnly: T.bool,
  short: T.bool,
  button: T.any,
}

Input.defaultProps = {
  type: 'text',
  placeholder: ' ',
  onChange: () => {},
}
